/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of the sales unit
 * @export
 * @interface Conversion
 */
export interface Conversion {
    /**
     * 
     * @type {string}
     * @memberof Conversion
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof Conversion
     */
    factor?: string;
}

/**
 * Check if a given object implements the Conversion interface.
 */
export function instanceOfConversion(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ConversionFromJSON(json: any): Conversion {
    return ConversionFromJSONTyped(json, false);
}

export function ConversionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Conversion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
        'factor': !exists(json, 'factor') ? undefined : json['factor'],
    };
}

export function ConversionToJSON(value?: Conversion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'unit': value.unit,
        'factor': value.factor,
    };
}

